import classNames from "classnames";
import { v4 as uuid } from "uuid";
import { Icon, IconsType } from "./Icon";

const PROCESS_COLORS = {
    blue: { bd: "border-blue", bg: "bg-blue" },
    red: { bd: "border-red", bg: "bg-red" },
    yellow: { bd: "border-yellow", bg: "bg-yellow" },
    green: { bd: "border-green", bg: "bg-green" },
};

export type TProcessItem = {
    title?: string;
    description?: string;
    icon?: IconsType;
    current?: boolean;
    line?: boolean | "dashed" | "dotted" | "double";
    color?: keyof typeof PROCESS_COLORS;
    lineColor?: keyof typeof PROCESS_COLORS;
};

type ProcessProps = {
    data?: TProcessItem[];
};

export const Process = ({ data }: ProcessProps) => {
    if (!data) return null;

    return (
        <div className="flex p-4 w-fit max-w-full overflow-x-auto">
            {data.map(({ title, description, icon, current, line = true, color = "blue", lineColor = color }) => {
                const hasTitle = Boolean(title);
                const hasDescription = Boolean(description);

                return (
                    <div key={uuid()} className="relative flex flex-col gap-2 [&_span]:last:hidden">
                        {Boolean(line) && (
                            <span
                                className={classNames(
                                    "absolute w-full border-b-2",
                                    PROCESS_COLORS[lineColor].bd,
                                    line === true && "top-2.5",
                                    line === "dashed" && "top-2.5 border-dashed",
                                    line === "dotted" && "top-2.5 border-dotted",
                                    line === "double" && "top-2 border-b-4 border-double",
                                )}
                            />
                        )}
                        <div
                            className={classNames(
                                "relative rounded-full border w-5 h-5",
                                PROCESS_COLORS[color].bd,
                                PROCESS_COLORS[color].bg,
                            )}
                        >
                            {icon && (
                                <Icon
                                    icon={icon}
                                    size="xs"
                                    className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-white"
                                />
                            )}
                        </div>
                        {(hasTitle || hasDescription) && (
                            <div className="flex flex-col gap-1 pr-10">
                                {hasTitle && (
                                    <div
                                        className={classNames(
                                            "text-sm font-semibold w-fit",
                                            current && "px-1 rounded text-white",
                                            current && PROCESS_COLORS[color].bg,
                                        )}
                                    >
                                        {title}
                                    </div>
                                )}
                                {hasDescription && <pre className="text-xs">{description}</pre>}
                            </div>
                        )}
                    </div>
                );
            })}
        </div>
    );
};
